import { render, staticRenderFns } from "./trainer-public-detail.vue?vue&type=template&id=44c7657a&scoped=true"
import script from "./trainer-public-detail.vue?vue&type=script&lang=js"
export * from "./trainer-public-detail.vue?vue&type=script&lang=js"
import style0 from "./trainer-public-detail.vue?vue&type=style&index=0&id=44c7657a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c7657a",
  null
  
)

export default component.exports